import React, { useState, useEffect, useContext, useRef } from "react";
import './header.scss';
import { FiHome } from "react-icons/fi";
import { IoMdMoon, IoIosArrowRoundBack } from "react-icons/io";
import { FaBell } from "react-icons/fa6";
import dummydp from '../../../assets/images/user.png';
import masterApi from "../../../services/masterApi";
import { AuthContext } from "../../../context/AuthContext";
import { useHeaderTitle } from "../layout";
import {  useLocation } from "react-router-dom";
import apiService from "../../../services/apiService"; 
import { Link } from 'react-router-dom';
export default function Header({ hideFilters }) {
    
    const location = useLocation();
    const { headerTitle } = useHeaderTitle();
    const [departmentLst, setDepartmentLst] = useState([]);
    const [accountLst, setAccountLst] = useState([]);
    const [countryLst, setCountryLst] = useState([]);
    const { accountFilterValue, setAccountFilterValue } = useContext(AuthContext);
    const { departmentFilterValue, setDepartmentFilterValue } = useContext(AuthContext);
    const { countryFilterValue, setCountryFilterValue } = useContext(AuthContext);
    const { yearFilterValue, setYearFilterValue } = useContext(AuthContext);
    const [isVisibleUserMenu, setIsVisibleUserMenu] = useState(false);
    const [isVisibleAdvanceFilter, setisVisibleAdvanceFilter] = useState(true)
    const [isMobile, setIsMobile] = useState(false);  
    const { handleLogout} = useContext(AuthContext);
    const userMenuRef = useRef(null);     
     const [notifications, setNotifications] = useState([]);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const notificationRef = useRef(null);

    // Calculate unread count
    const unreadCount = notifications.filter(n => n.isRead === false).length;

    const mainPages = ["/dashboard", "/candidate", "/job-list", "/users"]; // Add your main routes here


      const [userDetails, setUserDetails] = useState(null);
      const [designation, setDesignation] = useState(null);
      const [role, setRole] = useState(null);
      const [createdDate, setCreatedDate] = useState(null);
    
    // Function to load departments from API
    const loadDepartments = async () => {
        try {
            // Making API call
            const response = await masterApi.getActiveDepartments();
            // Check if activeDepartments exists in response and is an array
            if (response?.data?.activeDepartments && Array.isArray(response.data.activeDepartments)) {
                setDepartmentLst(response.data.activeDepartments);
            } else {
                console.error("No active departments found or response format is incorrect.");
                setDepartmentLst([]);
            }
        } catch (error) {
            console.error("Error loading departments:", error);
            setDepartmentLst([]); // Set to empty array on error
        }
    };
    const loadAccounts = async () => {
        try {
            //debugger;
            // Making API call
            const response = await masterApi.getActiveProjectAccounts();
            // Check if activeDepartments exists in response and is an array
            if (response?.data && Array.isArray(response.data)) {
                setAccountLst(response.data);
            } else {
                console.error("No active project account found or response format is incorrect.");
                setAccountLst([]);
            }
        } catch (error) {
            console.error("Error project accounts:", error);
            setAccountLst([]); // Set to empty array on error
        }
    };
    const loadCountry = async () => {
        try {
            //debugger;
            // Making API call
            const response = await masterApi.getAllCountry();
            //console.log(response);
            // Check if activeDepartments exists in response and is an array
            if (response?.data && Array.isArray(response.data)) {
                setCountryLst(response.data);
            } else {
                console.error("No active country found or response format is incorrect.");
                setCountryLst([]);
            }
        } catch (error) {
            console.error("Error loading countries:", error);
            setCountryLst([]); // Set to empty array on error
        }
    };
    const loadUserDetails = async () => {
        const userData = JSON.parse(localStorage.getItem('user'));
        if (userData) {
          setUserDetails(userData);
          if (userData?.designationId) {
            const designationData = await apiService.getActiveDesignations();
            setDesignation(designationData.find(d => parseInt(d.DesignationId) === parseInt(userData.designationId)));
          }
          const response = await masterApi.getRoleById(userData.roleId);
          if (response.data) {
            setRole(response.data.role);
            setCreatedDate(response.data.role.createdAt.split('T')[0]);
          }
        }
    }

    const handleAccountChange = (accountId) => {
        console.log("Selected Account ID:", accountId);
        setAccountFilterValue(accountId);
    };
    const handleCountryChange = (countryId) => {
        setCountryFilterValue(countryId);
    };
    const handleDepartmentChange = (deptId) => {
        setDepartmentFilterValue(deptId);
    };
    const handleYearChange = (year) => {
        setYearFilterValue(year);
    };
    // Load departments on component mount
    useEffect(() => {
        if (mainPages.includes(location.pathname)) {
        loadDepartments();
        loadAccounts();
        loadCountry();
     }        
        loadUserDetails();
    }, [location.pathname]);

useEffect(() => {
    const handleClickOutside = (event) => {
        if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
            setIsVisibleUserMenu(false);
        }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, []);

   const toggleUserMenu = (e) => {
    //e.stopPropagation();
    setIsVisibleUserMenu(prev => !prev);
};


    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            // On resize, update visibility: on desktop (mobile false) show content, on mobile hide content
            setisVisibleAdvanceFilter(!mobile);
        };

        // Set initial value
        handleResize();

        // Update on window resize
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleFilterDiv = () => {
        setisVisibleAdvanceFilter(prev => !prev);
    };



     // Close notification panel when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setIsNotificationOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleNotification = async () => {
    setIsNotificationOpen(prev => !prev);    
    if (!isNotificationOpen) {        
        await masterApi.markNotificationsRead();
        // Optionally, refresh notifications after marking as read
        const response = await masterApi.getNotifications();
        setNotifications(response?.data?.notifications || []);
    }
};


function getNotificationLink(note) {
  if (note.type === "JobApproved" && note.referenceId) {
    return `/job-list/job-details/${note.referenceId}`;
  }
  if (note.type === "InterviewScheduled" && note.referenceId) {
    return `/interview/details/${note.referenceId}`;
  }
  return "#";
}

    // Periodically fetch notifications
    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                // Replace with your actual API call
                const response = await masterApi.getNotifications();
                
                setNotifications(response?.data?.notifications || []);
            } catch (error) {
                setNotifications([]);
            }
        };

        fetchNotifications(); // Initial fetch

        const intervalId = setInterval(fetchNotifications, 30000); // every 30 seconds

        return () => clearInterval(intervalId); // cleanup on unmount
    }, []);


    return (
        <header>
            <nav aria-label="breadcrumb">

                <ol className="breadcrumb align-items-center">
                    <button
                    // onClick={goToDashboard}
                    ><FiHome /></button>
                    <li className="breadcrumb-item"></li>
                    <li className="breadcrumb-item active" aria-current="page">{headerTitle}</li>
                </ol>
            </nav>
            <div className="d-flex align-items-center gap-3 flex-wrap">
                <h1 className="poppins-medium">{headerTitle}</h1>
                <div className="ms-auto top-right-options ">
                    <div className="d-flex gap-2 align-items-center ">
                        <div className="d-flex gap-2 align-items-center">
                            {isMobile && (
                                <button onClick={toggleFilterDiv} className="btn btn-outline-primary">
                                    {isVisibleAdvanceFilter ? 'Hide Filter' : 'Show Filter'}
                                </button>
                            )}
                            {isVisibleAdvanceFilter && !hideFilters && (

                                <div className="d-flex gap-2 align-items-center mobile-filter-holder">
                                    <select className="form-select w-180" aria-label="account" onChange={(e) => handleAccountChange(e.target.value)}>
                                        <option key="Account" value="0">Account</option>
                                        {accountLst?.map((account) => (
                                            <option key={account.id} value={account.id}>
                                                {account.name}
                                            </option>
                                        ))}
                                    </select>
                                    <select className="form-select w-180" aria-label="department" onChange={(e) => handleDepartmentChange(e.target.value)}>
                                        <option value="">Department</option>
                                        {departmentLst?.map((department) => (
                                            <option key={department.id} value={department.id}>
                                                {department.title}
                                            </option>
                                        ))}
                                    </select>
                                    <select className="form-select w-120" aria-label="country" onChange={(e) => handleCountryChange(e.target.value)}>
                                        <option defaultValue>Country</option>
                                        {countryLst?.map((country) => (
                                            <option key={country.id} value={country.id}>
                                                {country.name}
                                            </option>
                                        ))}
                                    </select>
                                    <select className="form-select w-120" aria-label="year" onChange={(e) => handleYearChange(e.target.value)}>
                                        <option defaultValue value="">Year</option>
                                        {Array.from(
                                            { length: new Date().getFullYear() - 2024 + 1 },
                                            (_, i) => {
                                                const year = new Date().getFullYear() - i;
                                                return (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                );
                                            }
                                        )}
                                </select>
                                </div>
                            )}

                        </div>
                        <div className="ms-auto right-icons">
                            <div className="d-flex gap-2 align-items-center">
                                {/* <button className="btn icon-btn btn-light">
                            <IoMdMoon />
                        </button> */}
                                <button className="btn icon-btn btn-light position-relative" onClick={toggleNotification}>
                        <FaBell />
                        {unreadCount > 0 && (
                            <span className="notification-badge">{unreadCount}</span>
                        )}
                    </button>
                  {isNotificationOpen && (
  <div ref={notificationRef} className="notification-dropdown position-absolute">
    <div className="p-3">
      <h6>Notifications</h6>
      {notifications.length > 0 ? (
        notifications.map((note, idx) => (
          <React.Fragment key={idx}>
            <Link to={getNotificationLink(note)} className="notification-item">
              {note.message}
            </Link>
            {idx !== notifications.length - 1 && <hr className="notification-separator" />}
          </React.Fragment>
        ))
      ) : (
        <p>No new notifications.</p>
      )}
    </div>
  </div>
)}
                                <div
    ref={userMenuRef}
    className={`userDeck d-flex gap-2 align-items-center position-relative ${isVisibleUserMenu ? 'dropDown-active' : ''}`}
>
    <div className="dp-holder" onClick={toggleUserMenu}>
        <img src={dummydp} alt="ZeaRecruit" />
    </div>
    {isVisibleUserMenu && (
        <div className="user-dropdown position-absolute">
            <div className="user-info d-flex flex-column p-3">
                <h6>{userDetails?.firstName} {userDetails?.lastName}</h6>
                <span className="fst-italic">{role?.roleName}</span>
            </div>
            <button className="p-3 fw-medium" onClick={handleLogout}>Logout</button>
        </div>
    )}
</div>
                            </div>

                            {/* <div className="user-info d-flex flex-column">
                                <h6>Douglas Mathews</h6>
                                <span className="fst-italic">Admin</span>
                            </div> */}

                            {/* <div className="user-info d-flex flex-column">
                            <button className="dropdown-item"  onClick={handleLogout}>
                                Logout
                            </button>
                            </div> */}
                        </div>

                    </div>
                </div>
            </div>
        </header>
    )
}